import { Image } from 'primereact/image'
import React from 'react'
import { getBrand } from '../../utils/tenant'

const LogoDark = () => {
    const brand = getBrand()
    return (
        <div className="grid justify-content-center mt-5 mb-5">
            {brand.logoImg ? (
                <Image src={brand.logoImg} width="200"/>
            ) : (
                <div className="text-white font-bold text-4xl">{brand.logoText}</div>
            )}
        </div>
    )
}

export default LogoDark
